import React, { ChangeEvent, FC } from 'react'
import { Card, CardInner } from 'components/Card'
import { SelectBox, TextInput } from 'components/Form'
import { Spacer } from 'components/Utility'
import { categoryStatusOptions } from 'constants/options'

type Props = {
  name: string
  handleCategoryName: (event: ChangeEvent<HTMLInputElement>) => void
  selectCategoryDisabled: (value: string) => void
  status: string
}

const CategoryCard: FC<Props> = (props) => {
  const { name, handleCategoryName, selectCategoryDisabled, status } = props

  return (
    <Card>
      <CardInner>
        <TextInput
          disabled={false}
          label={'タグ名'}
          onChange={handleCategoryName}
          required={true}
          size={'small'}
          type={'text'}
          value={name}
        />
        <Spacer size={20} />
        <SelectBox options={categoryStatusOptions} select={selectCategoryDisabled} value={status} />
      </CardInner>
    </Card>
  )
}

export default CategoryCard
